/**
 * 首页结构化数据（Organization / WebSite / 五大AI服务 ItemList）。
 * 原 JSON_LD 常量拆为双语两份（i18n）：嵌套深，t() 键化可读性差，按语言整体切换。
 */

const jsonLdZh = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@id': 'https://www.xiangjifanyi.com/#organization',
      '@type': 'Organization',
      alternateName: ['象寄AI', 'Xiangji Translation'],
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.xiangjifanyi.com/home/apple-touch-icon.png',
      },
      name: '象寄翻译',
      url: 'https://www.xiangjifanyi.com/',
    },
    {
      '@id': 'https://www.xiangjifanyi.com/home/#website',
      '@type': 'WebSite',
      inLanguage: 'zh-CN',
      name: '象寄翻译 - 跨境电商AI翻译与营销平台',
      publisher: {'@id': 'https://www.xiangjifanyi.com/#organization'},
      url: 'https://www.xiangjifanyi.com/home/',
    },
    {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: 'AI智能识别并翻译图片文字,保留原版式与设计',
            name: '图片翻译',
            operatingSystem: 'Web',
            url: 'https://www.xiangjifanyi.com/home/image-translator',
          },
          position: 1,
        },
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: 'AI字幕翻译与配音,视频内容一键出海',
            name: '视频翻译',
            operatingSystem: 'Web',
            url: 'https://www.xiangjifanyi.com/home/video-translator',
          },
          position: 2,
        },
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: '一键生成多语言主图与详情图,提升 Listing 转化',
            name: '主图/详情图生成',
            operatingSystem: 'Web',
            url: 'https://www.xiangjifanyi.com/detail-page/',
          },
          position: 3,
        },
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: 'AI生成电商商品场景图与营销素材',
            name: '商品图片生成',
            operatingSystem: 'Web',
            url: 'https://www.xiangjifanyi.com/fusion/workspace',
          },
          position: 4,
        },
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: '面向跨境电商的多平台数字化营销解决方案',
            name: '跨境数字化营销',
            operatingSystem: 'Web',
          },
          position: 5,
        },
      ],
      name: '五大AI服务',
    },
  ],
};

const jsonLdEn = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@id': 'https://www.xiangjifanyi.com/#organization',
      '@type': 'Organization',
      alternateName: ['象寄AI', 'Xiangji Translation'],
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.xiangjifanyi.com/home/apple-touch-icon.png',
      },
      name: 'Xiangji AI',
      url: 'https://www.xiangjifanyi.com/',
    },
    {
      '@id': 'https://www.xiangjifanyi.com/home/#website',
      '@type': 'WebSite',
      inLanguage: 'en',
      name: 'Xiangji AI - Cross-border AI Translation & Marketing Platform',
      publisher: {'@id': 'https://www.xiangjifanyi.com/#organization'},
      url: 'https://www.xiangjifanyi.com/home/',
    },
    {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: 'AI-powered text recognition and translation in images, preserving the original layout',
            name: 'Image Translation',
            operatingSystem: 'Web',
            url: 'https://www.xiangjifanyi.com/home/image-translator',
          },
          position: 1,
        },
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: 'AI subtitle translation and dubbing to take video content global in one click',
            name: 'Video Translation',
            operatingSystem: 'Web',
            url: 'https://www.xiangjifanyi.com/home/video-translator',
          },
          position: 2,
        },
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: 'Generate multilingual main and detail images in one click to boost Listing conversion',
            name: 'Main & Detail Images',
            operatingSystem: 'Web',
            url: 'https://www.xiangjifanyi.com/detail-page/',
          },
          position: 3,
        },
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: 'AI-generated product scene images and marketing creatives for e-commerce',
            name: 'Product Image Generation',
            operatingSystem: 'Web',
            url: 'https://www.xiangjifanyi.com/fusion/workspace',
          },
          position: 4,
        },
        {
          '@type': 'ListItem',
          item: {
            '@type': 'SoftwareApplication',
            applicationCategory: 'BusinessApplication',
            description: 'Multi-platform digital marketing solutions for cross-border e-commerce',
            name: 'Cross-border Marketing',
            operatingSystem: 'Web',
          },
          position: 5,
        },
      ],
      name: 'Five AI Services',
    },
  ],
};

/** 按语言选择结构化数据 */
export const getJsonLd = (language: string) => (language === 'en' ? jsonLdEn : jsonLdZh);
